import { render, staticRenderFns } from "./order-regional-distribution.vue?vue&type=template&id=3cc76879&scoped=true&"
import script from "./order-regional-distribution.vue?vue&type=script&lang=js&"
export * from "./order-regional-distribution.vue?vue&type=script&lang=js&"
import style0 from "./order-regional-distribution.vue?vue&type=style&index=0&id=3cc76879&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc76879",
  null
  
)

export default component.exports